import React from 'react'
import {FiSearch} from "react-icons/fi"
import Coins from './Coins'
const Header = () => {
    return (
        <div className="header-container">
            <div className="sondaria-header-logo">
                <div className="login-top-logo">
                    <svg xmlns="http://www.w3.org/2000/svg" className="signup-login-logo-icon" viewBox="0 0 35 35">
                        <path id="Tracé_53" data-name="Tracé 53" d="M219.49,200.118a2.435,2.435,0,0,0-.712,1.929q.047.545.048,1.1a12.613,12.613,0,1,1-4.038-9.248l-8.677,8.677-4.739-4.739-3.419,3.418L202.693,206h0l2.146,2.146a1.8,1.8,0,0,0,2.546,0L209.53,206h0l3.259-3.259s4.878-4.876,4.878-4.875l2.206-2.206a2.422,2.422,0,0,0,.2-3.195,17.469,17.469,0,0,0-13.835-6.813,17.5,17.5,0,1,0,17.478,17.5q0-.774-.066-1.532a2.44,2.44,0,0,0-4.158-1.5Z" transform="translate(-188.715 -185.65)" fill="#00B8A9" />
                    </svg>
                    Sondaria
                </div>
            </div>
            <div className="sondaria-search-area">
                <div className="sondaria-search-bar">
                    <FiSearch className="sondaria-header-search-icon"/>
                    <input type="text" placeholder="Rechercher" />
                </div>
            </div>
            <div className="sondaria-points-area">
                <Coins/>
            </div>
            <div className="sondaria-header-button">
                <button className="header-top-btn">Creer un sondage</button>
            </div>
        </div>
    )
}

export default Header
